/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class ConfigurationCacheService {

        private processConfigCacheDictionary = {};

        public constructor(
            private $q: angular.IQService,
            private $http: angular.IHttpService,
            private configurationStorageService: services.ConfigurationStorageService) {
        }

        public getVersionedProcessConfiguration(id: string): angular.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            var d = this.$q.defer();
            var processConfiguration: Wars.Domain.Model.ProcessConfiguration;

            // Check in memory cache first
            processConfiguration = this.getProcessConfigFromCache(id);
            if (processConfiguration !== undefined && processConfiguration !== null) {
                d.resolve(processConfiguration);
                return d.promise;
            }

            // Not in memory check local storage
            this.configurationStorageService.getProcessConfigFromLocalStorage(id).then(pc => {
                if (pc !== undefined && pc !== null) {
                    this.addProcessConfigToCache(id, pc);
                    d.resolve(pc);
                    return d.promise;
                } else {
                    // Not in memory or local storage - make call to server to get the process configuration
                    this.$http.get('api/ConfigSnapshot/ProcessConfiguration/' + id).then(
                        (result) => {
                            var byteArray: any = result.data;
                            processConfiguration =
                                this.configurationStorageService.storeProcessConfigInLocalStorage(id, byteArray);
                            this.addProcessConfigToCache(id, processConfiguration);
                            d.resolve(processConfiguration);
                        });
                }
            });

            return d.promise;
        }

        public getActiveSystemLevelConfiguration(): ng.IPromise<Wars.Domain.Model.Dtos.ConfigSnapshotDto> {
            var defer = this.$q.defer();

            var url = "./api/ConfigSnapshot/GetActiveSystemLevel";
            this.$http.get(url).then(
                (result: any) => {
                    if (!result) return undefined;
                    var config: Wars.Domain.Model.Dtos.ConfigSnapshotDto = result.data;
                    defer.resolve(config);
                });

            return defer.promise;
        }

        public activateSystemLevelConfiguration(): ng.IPromise<Wars.Domain.Model.Dtos.ConfigSnapshotDto> {
            var defer = this.$q.defer();

            var url = "./api/ConfigSnapshot/Activate";
            this.$http.post(url, undefined).then(
                (result: any) => {
                    var config: Wars.Domain.Model.Dtos.ConfigSnapshotDto = result.data;
                    defer.resolve(config);
                });

            return defer.promise;
        }

        public getSystemStatuses(): ng.IPromise<Wars.Domain.Model.Dtos.FlatStatusAndStateDto[]> {
            var defer = this.$q.defer();

            var url = "./api/ConfigSnapshot/GetSystemStatusCodes";
            this.$http.get(url).then(
                (result: any) => {
                    defer.resolve(result.data);
                });

            return defer.promise;
        }

        public getSystemStates(): ng.IPromise<Wars.Domain.Model.Dtos.FlatStatusAndStateDto[]> {
            var defer = this.$q.defer();

            var url = "./api/ConfigSnapshot/GetSystemStateCodes";
            this.$http.get(url).then(
                (result: any) => {
                    defer.resolve(result.data);
                });

            return defer.promise;
        }

        public getProcessStates(processConfigId: string): ng.IPromise<Wars.Domain.Model.Dtos.FlatStatusAndStateDto[]> {
            var defer = this.$q.defer();

            var url = "./api/ConfigSnapshot/GetProcessStateCodes/" + processConfigId;
            this.$http.get(url).then(
                (result: any) => {
                    defer.resolve(result.data);
                });

            return defer.promise;
        }

        public getSystemClaimGroups(): ng.IPromise<Wars.Domain.Model.Dtos.ClaimGroupDto[]> {
            var defer = this.$q.defer();

            var url = "./api/ConfigSnapshot/GetClaimGroups";
            this.$http.get(url).then(
                (result: any) => {
                    defer.resolve(result.data);
                });

            return defer.promise;
        }

        public getSystemReviewGroups(): ng.IPromise<Wars.Domain.Model.Dtos.ReviewGroupDto[]> {
            var defer = this.$q.defer();

            var url = "./api/ConfigSnapshot/GetReviewGroups";
            this.$http.get(url).then(
                (result: any) => {
                    defer.resolve(result.data);
                });

            return defer.promise;
        }

        private addProcessConfigToCache(id: string, processConfig: Wars.Domain.Model.ProcessConfiguration): void {
            this.processConfigCacheDictionary[id] = processConfig;
        }

        private getProcessConfigFromCache(id: string): Wars.Domain.Model.ProcessConfiguration {
            return this.processConfigCacheDictionary[id];
        }
    }
}

warsApp.registerService('ConfigurationCacheService', ['$q', '$http', "configurationStorageService"]);